import React, { Component } from 'react'
import { Link } from 'react-router'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import LiveInfo from './LiveInfo'
import Poster from '../ReportForm/Poster'
import { LIVE_MANAGE_PATH } from '@constant'
import { Alert } from 'hljd'

@observer
export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
  }
  componentDidMount() {
    const {
      params: { id }
    } = this.props
    this.store.init(id)
  }
  render() {
    const header = [<Link to={LIVE_MANAGE_PATH}>视频直播</Link>, '查看提报单']
    const { status, auditing_remark } = this.store

    // 审核状态 1未编辑 2待审核 3审核通过 4审核拒绝
    const showStatus = +status === 3 || +status === 4
    return (
      <HeaderView header={header} title={'上次审核意见'}>
        {showStatus &&
          (status == 4 ? (
            <Alert
              style={{ marginTop: 20, color: '#FF801A' }}
              message={`审核未通过，${auditing_remark}`}
              type="warning"
              showIcon
            />
          ) : (
            <Alert
              style={{ marginTop: 20, color: '#2fc286' }}
              message="审核通过"
              type="success"
              showIcon
            />
          ))}
        <LiveInfo store={this.store} />
        <Poster />
      </HeaderView>
    )
  }
}
